export default __webpack_public_path__ + "static/media/orangecircle.a56bbd2a.png";